import React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';

export type CenterCenterStackProps = StackProps;

const CenterCenterStack = ({ children, ...rest }: CenterCenterStackProps) => {
  return (
    <Stack
      className="EvoCenterCenterStack-root"
      {...rest}
      sx={[{
        justifyContent: "center",
        alignItems: "center",
        height: 1
      }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {children}
    </Stack>
  );
};

export default CenterCenterStack;
